import React, { useState } from "react";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import { Get_Schools_Fuzzy_Search } from "../api/Get_Schools_Fuzzy_Search";
import { Link } from "react-router-dom";
import DisplayExport from "../../../components/Exports/DisplayExport";
import TableOfViewSchoolEvents from "./components/TableOfViewSchoolEvents";
import { Get_School_Events_Fuzzy_Search } from "../api/Get_School_Events_Fuzzy_Search";
import SearchBar from "./components/SearchBar";
import { StaffuseAuth } from "../../../security/StaffuseAuth";

function ViewSchoolEventsOld() {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Data---------------------------------------------

  // Assuming you have a state to store the fetched data
  const [Events, setEvents] = useState([]);
  //The below is the useEffect to fetch data from the backend
  Get_School_Events_Fuzzy_Search(
    "Schools",
    "Events_2025",
    "",
    localStorage.getItem("Username"),
    1000,
    setEvents,
    logout
  );

  //-----------------------------Begin Sorting---------------------------------------------
  // Assuming the rest of your component is defined here
  const [sortField, setSortField] = useState("Date"); // Default sort by 'Text'
  const [sortDirection, setSortDirection] = useState("desc"); // 'asc' or 'desc'

  // Function To sort table
  const sortArray = (Events, field, direction) => {
    return Events.sort((a, b) => {
      if (a[field] < b[field]) return direction === "asc" ? -1 : 1;
      if (a[field] > b[field]) return direction === "asc" ? 1 : -1;
      return 0;
    });
  };

  // Sort table when sortField or sortDirection changes
  const sortedEvents = sortArray([...Events], sortField, sortDirection);

  // Function To handle header click
  const handleHeaderClick = (field) => {
    if (field === sortField) {
      // Toggle sort direction
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc"); // Default To ascending when changing sort field
    }
  };

  //-----------------------------Components--------------------------------------------

  function DisplayViewOfSchoolEventsTable({ sortedEvents, handleHeaderClick }) {
    //This is the flex item
    return (
      <Box
        component="main"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          maxHeight: "700px",
          flexGrow: 1,
          p: 1,
        }}
      >
        <Typography variant="h6" gutterBottom>
          View School Events
        </Typography>
        <TableContainer
          component={Paper}
          sx={{
            width: "100%",
            margin: "0 auto",
            overflow: "auto",
          }}
        >
          <TableOfViewSchoolEvents
            sortedEvents={sortedEvents}
            handleHeaderClick={handleHeaderClick}
          />
        </TableContainer>
      </Box>
    );
  }

  const StatsCard = ({ title, value }) => {
    return (
      <div className="stats-card">
        <h4>{title}</h4>
        <p>{value}</p>
      </div>
    );
  };

  let CountOfEvents = Events.length;
  let CountOfHotEvents = Events.filter((event) => event.Heat === "Hot").length;
  let CountOfWarmEvents = Events.filter(
    (event) => event.Heat === "Warm"
  ).length;
  let CountOfColdEvents = Events.filter(
    (event) => event.Heat === "Cold"
  ).length;
  let CountOfInterstedInTCSEvents = Events.filter(
    (event) =>
      event.Careers_School_Proposal === "Yes-Hot" ||
      event.Careers_School_Proposal === "Yes-Warm" ||
      event.Careers_School_Proposal === "Yes-Cold"
  ).length;
  let CountOfNotInterstedInTCSEvents = Events.filter(
    (event) => event.Careers_School_Proposal === "No"
  ).length;
  let CountOfNotAskedAboutTCSEvents = Events.filter(
    (event) =>
      event.Careers_School_Proposal !== "Yes-Hot" &&
      event.Careers_School_Proposal !== "Yes-Warm" &&
      event.Careers_School_Proposal !== "Yes-Cold" &&
      event.Careers_School_Proposal !== "No"
  ).length;

  //-----------------------------Return--------------------------------------------

  return (
    <div style={{ backgroundColor: "#e5e5e5", minHeight: "93vh" }}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        {/* Left Column */}
        <div style={{ width: "80%", display: "flex", flexDirection: "column" }}>
          <div
            style={{
              flexWrap: "wrap",
              justifyContent: "flex-start",
              display: "flex",
              flexDirection: "row", // Stack SearchBar and DisplayExport vertically
            }}
          >
            <SearchBar setEvents={setEvents} />
            <DisplayExport
              excelData={sortedEvents}
              fileName="School_Events_Data"
            />
          </div>
          <DisplayViewOfSchoolEventsTable
            style={{ flex: "1" }} // Take remaining space
            sortedEvents={sortedEvents}
            handleHeaderClick={handleHeaderClick}
          />
        </div>
      </div>
    </div>
  );
}

export default ViewSchoolEventsOld;
